import { Container, Slider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

type SetStateAction = React.Dispatch<React.SetStateAction<number>>;

type CanvasSliderContainerProps = {
  setBGHue: SetStateAction;
  setBGVal: SetStateAction;
  setTitleX: any;
  setTitleY: any;
  setDowY: any;
  setWeekEndY: any;
  titleXDefault: any;
  titleYDefault: any;
  dowYDefault: any;
  weekEndYDefault: any;
  setTitleFontSize: any;
  titleFontSizeDefault: any;
};

const CanvasSliderContainer: React.FC<CanvasSliderContainerProps> = ({
  setBGHue,
  setBGVal,
  setTitleX,
  setTitleY,
  setTitleFontSize,
  setDowY,
  setWeekEndY,
  titleXDefault,
  titleYDefault,
  titleFontSizeDefault,
  dowYDefault,
  weekEndYDefault,
}) => {
  const { t } = useTranslation();

  const changeSliderValue = (setEvent: SetStateAction, newValue: any) => {
    setEvent(Number(newValue));
  };

  return (
    <Container maxWidth="sm">
      <Grid>
        <div>{t("colorChangeComponents.changeColor")}</div>
        <Slider
          min={0}
          max={259}
          step={1}
          defaultValue={0}
          onChange={(e, newVal) => {
            changeSliderValue(setBGHue, newVal);
          }}
        />
        <div>{t("colorChangeComponents.changeBrightness")}</div>
        <Slider
          min={-1}
          max={1}
          step={0.1}
          defaultValue={0}
          onChange={(e, newVal) => {
            changeSliderValue(setBGVal, newVal);
          }}
        />
        <div>タイトルフォントサイズ</div>
        <Slider
          min={10}
          max={100}
          defaultValue={titleFontSizeDefault}
          step={0.1}
          onChange={(e, newVal) => {
            changeSliderValue(setTitleFontSize, newVal);
          }}
        ></Slider>
        <div>タイトルX軸</div>
        <Slider
          min={0}
          max={20}
          defaultValue={titleXDefault}
          step={0.01}
          onChange={(e, newVal) => {
            changeSliderValue(setTitleX, newVal);
          }}
        />
        <div>タイトルY軸</div>
        <Slider
          min={0}
          max={20}
          defaultValue={titleYDefault}
          step={0.01}
          onChange={(e, newVal) => {
            changeSliderValue(setTitleY, newVal);
          }}
        ></Slider>
        <div>平日:曜日Y軸</div>
        <Slider
          min={0}
          max={100}
          defaultValue={dowYDefault}
          step={0.1}
          onChange={(e, newVal) => {
            changeSliderValue(setDowY, newVal);
          }}
        ></Slider>
        <div>休日:曜日Y軸</div>
        <Slider
          min={0}
          max={150}
          defaultValue={weekEndYDefault}
          step={0.1}
          onChange={(e, newVal) => {
            changeSliderValue(setWeekEndY, newVal);
          }}
        ></Slider>
      </Grid>
    </Container>
  );
};

export default CanvasSliderContainer;
